import { defineMessages } from 'react-intl';

export const LastLogin = defineMessages({
  message: {
    currentIP: {
      id: 'login.lastLogin.message.currentIP',
      describe: `A message showing the user's last login when that login was from the same IP address as the current user's. Consists of the user-formatted date and time`,
      defaultMessage: `Your last login was on {loginDate} at {loginTime}`
    },
    differentIP: {
      id: 'login.lastLogin.message.differentIP',
      describe: `A message showing the user's last login when that login was from a different IP address than the current user's. Consists of the user-formatted date and time and the IP address associated with the login`,
      defaultMessage: `Your last login was on {loginDate} at {loginTime} from IP address {ipAddress}`
    }
  }
});



// WEBPACK FOOTER //
// ./js/messages/modules/Login/LastLogin.js